import type { ResolvedAssets } from './assets';
import type { Edge, Node } from '@/types/node';

export const MAX_SUBFLOW_TEMPLATE_NAME_LENGTH = 150;
export const MAX_SUBFLOW_TEMPLATE_DESCRIPTION_LENGTH = 1000;

export enum SubflowTemplateType {
  SavedModel = 'saved_model',
  SavedNode = 'saved_node',
  Subflow = 'subflow',
}

export interface SubflowTemplateGroupMetadata {
  color?: string;
  labelFontSize?: number;
}

export interface SubflowTemplateData {
  nodes: Node[];
  edges?: Edge[];
  groupMetadata?: SubflowTemplateGroupMetadata;
}

export interface CreateSubflowTemplateRequestDto {
  type: SubflowTemplateType;
  name: string;
  description?: string;
  data: SubflowTemplateData;
  icon?: string;
  thumbnail?: string;
  thumbnailKey?: string;
  sourceNodeDefinitionId?: string;
  sourceWorkflowId?: string;
}

export interface EditSubflowTemplateRequestDto {
  name?: string;
  description?: string;
  icon?: string;
  thumbnail?: string;
  thumbnailKey?: string;
  sourceWorkflowId?: string;
}

export interface SubflowTemplateResponseDto {
  id: string;
  workspaceId: string;
  type: SubflowTemplateType;
  createdBy: string;
  name: string;
  description?: string;
  data?: SubflowTemplateData;
  icon?: string;
  thumbnail?: string;
  thumbnailKey?: string;
  // Signed and expiring. Display only — never send this back.
  thumbnailDisplayUrl?: string;
  /** Signed urls for the assets in `data.nodes` */
  resolvedAssets?: ResolvedAssets;
  sourceNodeDefinitionId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListSubflowTemplatesResponseDto {
  workspaceSubflowTemplates: SubflowTemplateResponseDto[];
}
